import React from "react";
import cx from "classnames";
import styles from "./styles.module.scss";
import PropTypes from "prop-types";

/**
Displays a div to be used with form validations

Example:
```
<FormErrorMessage>Please fill out the fields</FormErrorMessage>
```
*/
const FormErrorMessage = ({ className = "", children, ...others }) => (
  <div className={cx(styles.message, className)} role="alert" {...others}>
    {children}
  </div>
);

FormErrorMessage.propTypes = {
  /**
  Append class name
  */
  className: PropTypes.string
};

export default FormErrorMessage;
